import { c as _c } from "react/compiler-runtime";
import { DigitBadge } from "./ui/digit-badge";
import { Text } from "./ui/text";
export default function SubscriberCount(t0) {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <Text as="p" variant="prose">Join <DigitBadge value={count} /> other subscribers.</Text>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}